import { useSelector } from 'react-redux';
import { Eye, Loader2 } from 'lucide-react';
import { Button } from '@design-system';
import { selectClient } from '@client/model';
import { useViewPolicyDocument } from '@client/hooks/useViewPolicyDocument';

interface ViewPolicyDocumentButtonProps {
  requestId: string;
}

export function ViewPolicyDocumentButton({ requestId }: ViewPolicyDocumentButtonProps) {
  const client = useSelector(selectClient);
  const clientId = client?.clientId;
  const { viewDocument, isViewing } = useViewPolicyDocument(clientId);
  const viewing = isViewing(requestId);

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={() => viewDocument(requestId)}
      disabled={viewing}
      aria-label="View uploaded PDF"
      title="View uploaded PDF"
      className="w-fit"
    >
      {viewing ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <Eye className="h-4 w-4" />
      )}
      <span className="ml-1 hidden sm:inline">{viewing ? 'Opening…' : 'View Uploaded PDF'}</span>
    </Button>
  );
}
